'use client';

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

interface AnimatedCollapsibleContentProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

const AnimatedCollapsibleContent = ({
  open,
  children,
  className,
}: AnimatedCollapsibleContentProps) => (
  <AnimatePresence initial={false} mode="sync">
    {open && (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: 'auto',
          opacity: 1,
        }}
        exit={{
          height: 0,
          opacity: 0,
        }}
        transition={{
          height: {
            type: 'spring',
            stiffness: 500,
            damping: 40,
            mass: 0.8,
          },
          opacity: {
            duration: 0.15,
            ease: 'easeOut',
          },
        }}
        style={{ overflow: 'hidden', willChange: 'height, opacity' }}
        className={className}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);
AnimatedCollapsibleContent.displayName = 'AnimatedCollapsibleContent';

export { Collapsible, CollapsibleTrigger, CollapsibleContent, AnimatedCollapsibleContent };
